var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vxe-grid',{ref:"table",attrs:{"size":"small","row-id":"amzFirstDemandCode","border":"","auto-resize":"","highlight-hover-row":"","resizable":"","toolbar-config":_vm.tableToolbar,"data":_vm.tableData,"columns":_vm.tableColumns,"loading":_vm.loading,"height":_vm.tableHeight,"seq-config":{ startIndex: (_vm.tablePage.curPage - 1) * _vm.tablePage.pageSize }},scopedSlots:_vm._u([{key:"toolbar_form",fn:function(){return [_vm._t("header")]},proxy:true},{key:"pager",fn:function(){return [_vm._t("pager")]},proxy:true},{key:"amzFlipOrderStatus",fn:function(ref){
var row = ref.row;
return [_c('el-tag',{attrs:{"size":"mini","type":row.amzFlipOrderStatus == 'N'
            ? 'info'
            : row.amzFlipOrderStatus == 'S'
            ? ''
            : row.amzFlipOrderStatus == 'P'
            ? 'success'
            : row.amzFlipOrderStatus == 'R'
            ? 'danger'
            : row.amzFlipOrderStatus == 'D'
            ? 'danger'
            : row.amzFlipOrderStatus == 'T'
            ? ''
            : row.amzFlipOrderStatus == 'A'
            ? 'success'
            : row.amzFlipOrderStatus == 'B'
            ? 'danger'
            : ''}},[_vm._v(" "+_vm._s(row.v_amzFlipOrderStatus)+" ")])]}},{key:"amzFtyPurchaseStatus",fn:function(ref){
            var row = ref.row;
return [_c('el-tag',{attrs:{"size":"mini","type":row.amzFtyPurchaseStatus == 'A'
            ? 'success'
            : row.amzFtyPurchaseStatus == 'B'
            ? 'warning'
            : ''}},[_vm._v(" "+_vm._s(row.v_amzFtyPurchaseStatus)+" ")])]}},{key:"skuSalesChannel",fn:function(ref){
            var row = ref.row;
return [(row.v_skuSalesChannel)?_c('el-tag',{attrs:{"size":"mini","type":row.skuSalesChannel == 'V' ? 'warning' : ''}},[_vm._v(" "+_vm._s(row.v_skuSalesChannel)+" ")]):_vm._e()]}},{key:"createInfo",fn:function(ref){
            var row = ref.row;
return [_c('span',[_vm._v(_vm._s(row.createByName))]),_c('br'),_c('span',[_vm._v(_vm._s(row.createDate))])]}},{key:"modifyInfo",fn:function(ref){
            var row = ref.row;
return [_c('span',[_vm._v(_vm._s(row.modifyByName))]),_c('br'),_c('span',[_vm._v(_vm._s(row.modifyDate))])]}},{key:"empty",fn:function(ref){return [_c('div',{staticStyle:{"text-align":"center"}},[_c('img',{attrs:{"src":"/image/static/img/nodata.png"}}),_c('p',{staticClass:"no-data mt-1"},[_vm._v(" "+_vm._s(_vm.$l('INDEX.tips_no_data') || '暂无数据！')+" ")])])]}}],null,true)})],1)}
var staticRenderFns = []

export { render, staticRenderFns }